export const DEFAULT_ACCENT_COLOR = "#C9A870";
